// CORE
import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Layout from './hoc/Layout/Layout'

// ROUTES
import LogIn from './containers/LogIn/LogIn'
import FormsList from './containers/FormsList/FormsList'
import DraftsList from './containers/DraftsList/DraftsList'
import CompletedList from './containers/CompletedList/CompletedList'
import FormLayout from './containers/FormLayout/FormLayout'
import AuthService from './auth/Auth'

const AuthRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={props => (
		AuthService.checkAuth() ? (
			<Component {...props} />
		) : (
				<Redirect to={{
					pathname: '/',
					state: { from: props.location }
				}} />
			)
	)} />
)

class App extends Component {
	render() {
		return (
			<div>
				<Layout>
					<Switch>
						<Route path="/" exact component={LogIn} />
						<AuthRoute exact path="/consents" component={FormsList} />
						<AuthRoute exact path="/drafts" component={DraftsList} />
						<AuthRoute exact path="/complete" component={CompletedList} />
						<AuthRoute path="/form/:id" component={FormLayout} />
					</Switch>
				</Layout>
			</div>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/App.js